import events from "./data/events.json";
import data from "./data/data.json";

export const yellow = {
    50: '#FFFCEE',
    100: '#FFF9E6',
    200: '#FFF3CC',
    300: '#FFDE99',
    400: '#F1C152',
    500: '#E6AD00',
    600: '#CC9A00',
    700: '#B28700',
    800: '#997400',
    900: '#7F6100',
};

export const orange = {
    50: '#FFEFE5',
    100: '#FFDFCC',
    200: '#FFCEAA',
    300: '#FFBE88',
    400: '#FFAD66',
    500: '#ff0000',
    600: 'rgba(0, 0, 0,0.7)',
    700: 'black',
    800: '#A31B00',
    900: '#8C1700',
};


export const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

export function getDayName(idx) {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[idx];
}

export function getMonthName(idx) {
    const days = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return days[idx];
}

function formatDateTime(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = '00';
    return `${year}${month}${day}T${hours}${minutes}${seconds}`;
}

function generateDTSTAMP() {
    const now = new Date(); // Get current date and time
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hours = String(now.getUTCHours()).padStart(2, '0');
    const minutes = String(now.getUTCMinutes()).padStart(2, '0');
    const seconds = String(now.getUTCSeconds()).padStart(2, '0');
    return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
}

function generateICSEventData(event) {
    let { date, description, eventName, location, startTime, endTime } = event;
    // const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let startDate = event.startDate ? new Date(event.startDate) : new Date(date);
    let endDate = event.endDate ? new Date(event.endDate) : new Date(date);
    const userTimeZone = "Asia/Kolkata";

    if (!startTime) {
        startTime = startDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    }

    const [startHourStr, startMinuteStr, startAMPM] = startTime.split(/:|\s/); // Split with : or space
    let startHour = parseInt(startHourStr);
    const startMinute = parseInt(startMinuteStr);

    if (startAMPM && startAMPM.toUpperCase() === 'PM' && startHour !== 12) {
        startHour += 12; // Convert to 24-hour format for PM times (except 12 PM)
    } else if (startAMPM && startAMPM.toUpperCase() === 'AM' && startHour === 12) {
        startHour = 0; // Midnight (12 AM) is 0 in 24-hour formats
    }

    startDate.setHours(startHour, startMinute, 0, 0);
    const formattedStartDate = formatDateTime(startDate);


    let endTimeStr = "";
    if (endTime) {
        const [endHourStr, endMinuteStr, endAMPM] = endTime.split(/:|\s/);
        let endHour = parseInt(endHourStr);
        const endMinute = parseInt(endMinuteStr);

        if (endAMPM && endAMPM.toUpperCase() === 'PM' && endHour !== 12) {
            endHour += 12;
        } else if (endAMPM && endAMPM.toUpperCase() === 'AM' && endHour === 12) {
            endHour = 0;
        }
        endDate.setHours(endHour, endMinute, 0, 0);
        const formattedEndDate = formatDateTime(endDate);
        endTimeStr += `\nDTEND;TZID=${userTimeZone}:${formattedEndDate}`;
    }


    const uid = `${event.id}@parmarthsadhna.in`;
    // let regex = /(<([^>]+)>)/ig;
    // let calDesc =  description.replace(regex, "");
    let icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Parmarth Sadhna Charitable Trust//EN
CALSCALE:GREGORIAN
BEGIN:VTIMEZONE
TZID:Asia/Kolkata
X-LIC-LOCATION:Asia/Kolkata
BEGIN:STANDARD
TZOFFSETFROM:+0530
TZOFFSETTO:+0530
TZNAME:IST
DTSTART:19700101T000000
END:STANDARD
END:VTIMEZONE
BEGIN:VEVENT
UID:${uid}\r
DTSTAMP:${generateDTSTAMP()}\r
SUMMARY:${eventName}
DESCRIPTION:${eventName}
DTSTART;TZID=${userTimeZone}:${formattedStartDate}
LOCATION:${location.address.replace(/\n/g, '\\n')}`;

    if (endTimeStr.length > 0) {
        icsContent += endTimeStr;
    }

    icsContent += `\nEND:VEVENT
END:VCALENDAR`;
    return icsContent;
}

export function addToCalendar(event) {
    const icsContent = generateICSEventData(event)
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `event_${event.id}.ics`;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export function regenerateData(generate) {
    if (!generate) return null;
    let events = [];
    for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].dates.length; j++) {
            let event = {
                additionalEvents: data[i].additionalEvents,
                date: data[i].dates[j].date,
                description: data[i].dates[j].description || data[i].description,
                eventName: data[i].eventName,
                id: `${i}_${j}`,
                location: data[i].location,
                startTime: data[i].dates[j].startTime || data[i].startTime || "",
                endTime: data[i].dates[j].endTime || data[i].endTime || "",
                endDate: data[i].dates[j].endDate || data[i].endDate || ""
            }
            events.push(event);
        }
    }
    console.log(JSON.stringify(events));
}

export function getEventTimeString(event) {
    if (event.startTime) {
       if (event.endTime) {
           return event.startTime + " - " + event.endTime;
       } else {
           return event.startTime
       }
    }
    return event.date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

}

export function sortAndGroupEvents() {
    let sortedEvents = events.sort((a, b) => {
        let aDate = new Date(a.date);
        let bDate = new Date(b.date);
        return aDate.getTime() - bDate.getTime()
    });
    let eventsGrouped = {upcoming: [], past: []}
    sortedEvents.forEach((event) => {
        event.startDate = new Date(event.date);
        event.date = new Date(event.endDate || event.date);
        let tmpDate = new Date(event.date);
        let dateToday = new Date().setHours(0, 0, 0, 0);
        let eventDay = tmpDate.setHours(0, 0, 0, 0);
        if (eventDay < dateToday) {
            eventsGrouped.past.push(event);
        } else {
            eventsGrouped.upcoming.push(event);
        }
    })
    eventsGrouped.past = eventsGrouped.past.reverse();
    return eventsGrouped;
}

export function applyFilters(events, filters) {
    return events.filter(event => {
        let eventDate = new Date(event.date);
        if (
            filters.text && (
                !event.eventName?.toLowerCase().includes(filters.text.toLowerCase())
                && !event.description?.toLowerCase().includes(filters.text.toLowerCase())
                && (!event.location.address?.toLowerCase().includes(filters.text.toLowerCase()))
            )
        ) {
            return false;
        }
        if (filters.country && filters.country.length && !filters.country.includes(event.location.country)) {
            return false;
        }
        if (filters.city && filters.city.length && !filters.city.includes(event.location.city)) {
            return false;
        }
        if (filters.startDate) {
            let sd = new Date(filters.startDate);
            if (sd.getTime() > eventDate.getTime()) {
                return false;
            }
        }
        if (filters.endDate) {
            let ed = new Date(filters.endDate);
            if (ed.getTime() + 24*60*60*1000 < eventDate.getTime()) {
                return false;
            }
        }
        if (filters.Months && filters.Months.length) {
           let tmpMatch = false;
            for (const month of filters.Months) {
                if (eventDate.getMonth() === month.id) {
                    tmpMatch = true;
                    break;
                }
            }
            if (!tmpMatch) {
                return false;
            }
        }
        if (filters.Kutiya && filters.Kutiya.length) {
            let tmpMatch = false;
            for (const kutiya of filters.Kutiya) {
                if (kutiya.id === event.location.kutiyaId) {
                    tmpMatch = true;
                    break;
                }
            }
            if (!tmpMatch) {
                return false;
            }
        }
        return true;
    })
}

export function calculateTimeLeft(eventDate) {
    const difference = +new Date(eventDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
        timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60)
        };
    }

    return timeLeft;
}

export function isDateToday(date) {return (new Date(date).setHours(0,0,0,0) === new Date().setHours(0,0,0,0))}